import * as Sentry from "@sentry/nextjs";
import { SPLIDE_TYPES } from "./splide-types.js";
import { SPLIDE_CONTENT_CONFIG, SPLIDE_NAV_CONFIG, SPLIDE_SLIDER_CONFIG } from "./splide-configs.js";
import { SPLIDE_ROLE_NAV, SPLIDE_ROLE_CONTENT, SPLIDE_ARROW_ELEMENT_SELECTOR, SPLIDE_ARROW_TYPE_ATTRIBUTE, SPLIDE_COMPONENT_NAME_ATTRIBUTE, SPLIDE_SLIDE_CLASS_SELECTOR, SPLIDE_DATA_FOCUS_ATTRIBUTE } from "./splide-constants.js";
import { addSplideClassNames, getActiveClassName, syncSplideActiveTabClassNames } from "./splide-class-helpers.js";
import { trackEvent } from "/services/bigbrain-service";
import { CAROUSEL_ARROW_CLICKED, TAB_CLICKED } from "/constants/bigbrain-event-types";
export const createSplideInstance = (root, config)=>{
    const Splide = window.Splide;
    if (!Splide) {
        return;
    }
    addSplideClassNames(root, config.arrows);
    return new Splide(root, config);
};
const createSliderInstance = (root)=>{
    const instance = createSplideInstance(root, SPLIDE_SLIDER_CONFIG);
    instance.mount();
    const splideComponentName = root.getAttribute(SPLIDE_COMPONENT_NAME_ATTRIBUTE);
    const sliderArrows = root.querySelectorAll(SPLIDE_ARROW_ELEMENT_SELECTOR);
    sliderArrows.forEach((arrow)=>{
        arrow.addEventListener("click", ()=>{
            const arrowType = arrow.getAttribute(SPLIDE_ARROW_TYPE_ATTRIBUTE);
            trackEvent(CAROUSEL_ARROW_CLICKED, {
                info1: splideComponentName,
                info3: arrowType
            });
        });
    });
};
const createTabsInstance = (root)=>{
    const splideNavElement = root.querySelector(SPLIDE_ROLE_NAV);
    const splideContentElement = root.querySelector(SPLIDE_ROLE_CONTENT);
    const splideNavFocus = splideNavElement.getAttribute(SPLIDE_DATA_FOCUS_ATTRIBUTE);
    const navInstance = createSplideInstance(splideNavElement, SPLIDE_NAV_CONFIG(splideNavFocus));
    const contentInstance = createSplideInstance(splideContentElement, SPLIDE_CONTENT_CONFIG);
    const activeClassName = getActiveClassName(splideNavElement);
    const syncActiveClass = ()=>syncSplideActiveTabClassNames(splideNavElement, activeClassName);
    navInstance.on('moved', syncActiveClass);
    contentInstance.sync(navInstance);
    navInstance.mount();
    contentInstance.mount();
    const navSlides = splideNavElement.querySelectorAll(SPLIDE_SLIDE_CLASS_SELECTOR);
    navSlides.forEach((slide, index)=>{
        slide.addEventListener("click", ()=>{
            const slideText = slide.innerText;
            trackEvent(TAB_CLICKED, {
                kind: slideText,
                info1: index
            });
        });
    });
};
const SPLIDE_FACTORY_MAP = {
    [SPLIDE_TYPES.SLIDER]: createSliderInstance,
    [SPLIDE_TYPES.TABS]: createTabsInstance
};
export const initializeSplideInstance = (root, type)=>{
    try {
        var _SPLIDE_FACTORY_MAP_type;
        (_SPLIDE_FACTORY_MAP_type = SPLIDE_FACTORY_MAP[type]) === null || _SPLIDE_FACTORY_MAP_type === void 0 ? void 0 : _SPLIDE_FACTORY_MAP_type.call(SPLIDE_FACTORY_MAP, root);
    } catch (err) {
        Sentry.captureException(err);
        Sentry.captureMessage(`Splide ${type} mount failed: ${err.message}`);
    }
};
